import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import i18n from "i18next";
import Checkbox from 'material-ui/Checkbox';
import RaisedButton from 'material-ui/RaisedButton';
import styles from '../../styles/styles';
import withTranslation from '../../hoc/withTranslation';
import {
    renderNumberField,
    renderTextField,
} from '../../services/form';
import '../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import ControlledEditor from '../form/ControlledEditor/ControlledEditor';
import ModuleService from '../../services/module';

const validate = values => {
    const errors = {};
    [
        'title',
        'display_order',
        'content'
    ].forEach(field => {
        if (!values[field]) {
            errors[field] = i18n.t('generic.required');
        }
    });
    if (
        values['tag'] !== undefined
        && values['tag'] !== null
        && values['tag'] !== ''
        && values['tag'].length > 100
    ) {
        errors['tag'] = i18n.t('generic.tag_length_gt_100');
    }
    return errors;
};

const renderCheckbox = ({ input, label }) => (
    <Checkbox
        label={label}
        onCheck={input.onChange}
    />
);

export class PageForm extends React.Component {

    static propTypes = {
        app: PropTypes.object,
        page: PropTypes.object,
        onFormReset: PropTypes.func,
    };

    // Handlers

    onResetForm = () => {
        this.props.reset();

        if (this.props.onFormReset) {
            this.props.onFormReset();
        }
    };

    // Render

    render() {
        const { handleSubmit, pristine, submitting, t } = this.props;
        return (
            <form onSubmit={handleSubmit}>
                <div>
                    <Field
                        id="title"
                        name="title"
                        component={renderTextField}
                        label={t('generic.title')}
                        fullWidth={true}
                    />
                    <Field
                        id="content"
                        name="content"
                        component={ControlledEditor}
                        initialValue={this.props.initialValues ? this.props.initialValues.content : ''}
                        label={t('generic.content')}
                        fullWidth={true}
                    />
                    <Field
                        type="number"
                        id="display_order"
                        name="display_order"
                        component={renderNumberField}
                        label={t('generic.display_order')}
                        fullWidth={true}
                        inputMode="numeric"
                        parse={(val) => parseInt(val, 10)}
                    />
                    <Field
                        id="tag"
                        name="tag"
                        component={renderTextField}
                        label="Tag"
                        fullWidth={true}
                    />
                    {this.props.app !== undefined &&
                    ModuleService.hasModule(this.props.app, ModuleService.PUSH) &&
                    ModuleService.isPushModuleConfigured(this.props.app) &&
                    this.props.page === undefined &&
                    <Field
                        name="push_entity"
                        component={renderCheckbox}
                        label={t('module.push.push_entity')}
                    />
                    }
                </div>
                <div style={styles.formButtons}>
                    <RaisedButton
                        style={styles.formButton}
                        label={t("generic.save")}
                        disabled={pristine || submitting}
                        type="submit"
                        primary={true}
                    />
                    {this.props.page === undefined &&
                    <RaisedButton
                        style={styles.formButton}
                        label={t("generic.save_and_create_new")}
                        disabled={pristine || submitting}
                        type="button"
                        primary={true}
                        onClick={() => {
                            // In case of success, handle submit returns undefined, otherwise it returns the list of errors
                            if (handleSubmit() === undefined) {
                                this.onResetForm();
                            }
                        }}
                    />
                    }
                    <RaisedButton
                        style={styles.formButton}
                        label={t("generic.reset")}
                        type="button"
                        disabled={pristine || submitting}
                        onClick={this.onResetForm}
                    />
                </div>
            </form>
        );
    }
}

export default reduxForm({
    form: 'editPage',
    validate,
})(withTranslation(PageForm));



// WEBPACK FOOTER //
// src/components/page/PageForm.js